import * as Yup from 'yup';
import t from '../../../../../utils/translate';

export default () =>
  Yup.object({
    bankType: Yup.string().required(t('Required field')),
    bankChooseBank: Yup.string().required(t('Required field')),
    accountNumber: Yup.string().required(t('Required field')),
  });
